import { AlertTriangle } from "lucide-react";

interface DuplicateWarningProps {
  field: string;
}

const DuplicateWarning = ({ field }: DuplicateWarningProps) => (
  <p className="flex items-center gap-1.5 text-xs text-amber-600 mt-1">
    <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
    Esse {field} já está no nosso cadastro. Caso seja você, faça login na sua conta.
  </p>
);

export default DuplicateWarning;
